import {
  PATH_NAME_AGREEMENT, PATH_NAME_BUSINESS, PATH_NAME_COMPANY, PATH_NAME_EVENT_BOARD_LIST,
  PATH_NAME_EVENT_BOARD_VIEW,
  PATH_NAME_EVENT_LIST,
  PATH_NAME_EVENT_VIEW,
  PATH_NAME_FAQ, PATH_NAME_FINANCIAL_STATEMENTS,
  PATH_NAME_NOTICE_LIST,
  PATH_NAME_NOTICE_VIEW, PATH_NAME_RECRUIT, PATH_NAME_SERVICE, PATH_NAME_USER_QNA
} from '@/common/resources/router.const'

export default [
  {
    path: 'customer',
    components: {
      customerLayout: () => import('@/pages/section/CustomerSupportLayout')
    },
    children: [
      {
        path: 'notice_list',
        name: PATH_NAME_NOTICE_LIST,
        meta: { tab: 'notice', type: 'notice' },
        alias: 'notice_list.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "notice_list" */'@/pages/customer/notice_list')
        }
      },
      {
        path: 'notice_view',
        name: PATH_NAME_NOTICE_VIEW,
        meta: { tab: 'notice', type: 'notice' },
        alias: 'notice_view.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "notice_view" */'@/pages/customer/notice_view')
        }
      },
      {
        path: 'faq',
        name: PATH_NAME_FAQ,
        meta: { tab: 'faq', type: 'notice' },
        alias: 'faq.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "faq" */'@/pages/customer/faq')
        }
      },
      {
        path: 'agreement',
        name: PATH_NAME_AGREEMENT,
        meta: { tab: 'agreement', type: 'notice' },
        alias: 'agreement.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "agreement" */'@/pages/customer/agreement')
        }
      },
      {
        path: 'event_list',
        name: PATH_NAME_EVENT_LIST,
        meta: { menu: 'event', type: 'event' },
        alias: 'event_list.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "event_list" */'@/pages/customer/event_list')
        }
      },
      {
        path: 'event_view',
        name: PATH_NAME_EVENT_VIEW,
        meta: { menu: 'event', type: 'event' },
        alias: 'event_view.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "event_view" */'@/pages/customer/event_view')
        }
      },
      {
        path: 'event_board_list',
        name: PATH_NAME_EVENT_BOARD_LIST,
        meta: { menu: 'board', type: 'event' },
        alias: 'event_board_list.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "event_board_list" */'@/pages/customer/event_board_list')
        }
      },
      {
        path: 'event_board_view',
        name: PATH_NAME_EVENT_BOARD_VIEW,
        meta: { menu: 'board', type: 'event' },
        alias: 'event_board_view.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "event_board_view" */'@/pages/customer/event_board_view')
        }
      },
      {
        path: 'user_qna',
        name: PATH_NAME_USER_QNA,
        meta: { tab: 'user_qna', type: 'notice' },
        alias: 'user_qna.html',
        components: {
          customerContent: () => import(/* webpackChunkName: "user_qna" */'@/pages/customer/user_qna')
        }
      }
    ]
  },
  // 해더가 다름
  {
    path: '/customer/business',
    name: PATH_NAME_BUSINESS,
    alias: '/customer/business.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "business" */'@/pages/customer/business')
    }
  },
  {
    path: '/customer/recruit',
    name: PATH_NAME_RECRUIT,
    alias: '/customer/recruit.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "recruit" */'@/pages/customer/recruit')
    }
  },
  {
    path: '/customer/financial_statements',
    name: PATH_NAME_FINANCIAL_STATEMENTS,
    alias: '/customer/financial_statements.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "recruit" */'@/pages/customer/financial_statements')
    }
  },
  {
    path: '/customer/company',
    name: PATH_NAME_COMPANY,
    alias: '/customer/company.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "company" */'@/pages/customer/company')
    }
  },
  {
    path: '/customer/service',
    name: PATH_NAME_SERVICE,
    alias: '/customer/service.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "service" */'@/pages/customer/service')
    }
  }
]
